module.exports = __webpack_public_path__ + "static/img/hire_600.faae70c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hellohr/hire_600.png
// module id = uceM
// module chunks = 0